// /* eslint-disable no-unused-vars */

// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";

// import axios from "axios";
// import "../assets/Loan/LoanKyc.css";

// import { fetchDocuments } from "../redux/slices/kycuploadslice"; // <-- import your slice
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import { toast } from "react-toastify";

// import Select from "react-select";
// import { fetchCustomers } from "../redux/slices/Customer/customerReportSlice";
// export default function KycForm() {

//   const dispatch = useDispatch();
//   const [filterType, setFilterType] = useState("");
//   const [filterValue, setFilterValue] = useState("");
//   const [userDetails, setUserDetails] = useState(null);
//   const [docType, setDocType] = useState("");
//   const [docFile, setDocFile] = useState(null);
//   const [uploadedKyc, setUploadedKyc] = useState([]);
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [previewImage,setPreviewImage]= useState(null);
//   const [accounts, setAccounts] = useState([]);
//   const [selectedAccount,setSelectedAccount]=useState(null);

// const { profile, loading: profileLoading,  } = useSelector(
//     (state) => state.userProfile
//   );

//     const { documents, loading, error } = useSelector((state) => state.documents);
//   // Fetch profile
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//  useEffect(() => {
//   if (profile && profile.superAdminId) {
//     dispatch(fetchDocuments({ serviceId: profile.superAdminId, description: "Customer" }));
//   }
// }, [dispatch, profile]);

// const {
//     customers = [],
//   } = useSelector((state) => state.customerReport || {});

//   useEffect(() => {
//       if (!profile?.superAdminId) return;

//       dispatch(
//         fetchCustomers({

//           limit: Number(1000),
//           superAdminId: profile.superAdminId,
//           userId: undefined,

//         })
//       );
//     }, [
//       dispatch,
//       profile?.superAdminId,
//     ]);

//   const handleDelete = async (docId) => {
//     if (!window.confirm("Are you sure you want to delete this document?")) return;

//     try {
//       const res = await fetch(`https://payyug.in/api/delete-customer-kyc/${docId}`, {
//         method: "DELETE",
//         headers: {
//           "Content-Type": "application/json",
//           // Add auth token if required
//           // Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!res.ok) throw new Error("Failed to delete document");

//       // Remove deleted document from local state
//       setUploadedKyc(uploadedKyc.filter((doc) => doc.id !== docId));

//       toast.success(res?.data?.message||"Document deleted successfully");
//     } catch (error) {
//       console.error(error);
//       toast.error(error?.response?.data?.message||"Error deleting document");
//     }
//   };

//   // ------------------ Search User ------------------
//   const handleSearch = async () => {
//     if (!filterValue) {
//       toast.warn("Please enter a value to search.");
//       return;
//     }

//     const branchId = localStorage.getItem("userId") || "18";
//     let query = { branchId };

//     if (filterType === "customer id") query.userId = filterValue.trim();
//     else if (filterType === "pan") query.panNumber = filterValue.trim();
//     else if (filterType === "aadhaar") query.aadhaarNumber = filterValue.trim();
//     else if (filterType === "mobile") query.mobileNumber = filterValue.trim();
//     else {
//       toast.error("This filter type is not supported for API search.");
//       return;
//     }

//     try {
//       // Fetch user details
//       const response = await axios.get(
//         "https://payyug.in/api/customers-get-userId",
//         { params: query }
//       );

//       const user = response.data.data;
//       if (user && user.userId) {
//         const details = {
//           userId: user.userId,
//           Id: user.id,
//           name: user.fullName,
//           pan: user.panNumber,
//           aadhaar: user.aadhaarNumber,
//           mobile: user.mobileNumber,
//           dob: user.dateOfBirth?.slice(0, 10),
//           superAdminId: user.superAdminId,
//         };
//         setUserDetails(details);

//         // Fetch uploaded KYC for this user
//         const kycResponse = await axios.get(
//           `https://payyug.in/api/list-kyc`,
//           { params: { userId: user.userId ,

//              createdId: branchId,

//           } }
//         );

//         console.log("customer photo",kycResponse.data)
//         setUploadedKyc(kycResponse.data.documents || []);
//       } else {
//         setUserDetails(null);
//         setUploadedKyc([]);
//         toast.error("No user found.");
//       }
//     } catch (error) {
//       console.error("Error fetching user or KYC:", error);
//       toast.error("Failed to fetch user or KYC. Please try again.");
//     }
//   };

//   // ------------------ Upload/Create KYC ------------------
//   const handleUpload = async () => {
//     if (!docType || !docFile || !userDetails?.userId) {
//       toast.warn(
//         "Please select a document type, file, and ensure a user is selected."
//       );
//       return;
//     }

//     const createdId = localStorage.getItem("userId") || 123;
//     const createdBy = localStorage.getItem("username") || "demo";

//     try {
//       const formData = new FormData();
//       formData.append("userId", userDetails.userId);
//       formData.append("superAdminId", userDetails.superAdminId);
//       formData.append("docName", docType);
//       formData.append("file", docFile);
//       formData.append("status", "pending");
//       formData.append("createdBy", createdBy);
//       formData.append("createdId", createdId);

//       await axios.post("https://payyug.in/api/create-customer-kyc", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       // Refresh KYC list after upload
//       const kycResponse = await axios.get(`https://payyug.in/api/list-kyc`, {
//         params: {
//           userId: userDetails.userId,
//            createdId: createdId,
//          },
//       });
//       setUploadedKyc(kycResponse.data.documents || []);

//       setDocType("");
//       setDocFile(null);
//       toast.success(kycResponse?.data?.message||"KYC document uploaded successfully!");
//     } catch (err) {
//       console.error("Upload error:", err);
//       toast.error(err?.response?.data?.message||"Failed to upload KYC. Please try again.");
//     }
//   };

//   const handlepreviewclick = async (doc) => {
//     try {
//       const imageUrl = `https://payyug.in/uploads/${doc.docImage}`

//       if (imageUrl) {
//         setPreviewImage(imageUrl);
//       } else {
//         toast.error("Image not found.");
//       }
//     } catch (error) {
//       console.log(error);
//       toast.error("Error loading image.");
//     }
//   };

//   // ------------------ JSX ------------------
//   return (
//   <div className="BranchLoanKycUpload-container">
//     <h1>Customer KYC Upload</h1>

//       {/* Filter User */}
//       <section className="BranchLoanKycUpload-section">
//         <h2>1. Filter User</h2>
//         <div className="BranchLoanKycUpload-filter-row-wrapper">
//           <div className="BranchLoanKycUpload-filter-row">
//             <select
//               value={filterType}
//               onChange={(e) => {
//                 setFilterType(e.target.value);
//                 setFilterValue("");
//               }}
//             >
//               <option value="">Select Filter Type</option>
//               <option value="customer id">Customer ID</option>
//               {/* <option value="pan">PAN</option>
//               <option value="aadhaar">Aadhaar</option>
//               <option value="mobile">Mobile</option> */}
//             </select>

//             {filterType && (
//               // <input
//               //   type="text"
//               //   placeholder={`Enter ${filterType}`}
//               //   value={filterValue}
//               //   onChange={(e) => setFilterValue(e.target.value)}
//               // />

//                <Select
//                 className="account-select-container"
//                 classNamePrefix="account-select"
//                 placeholder="Search by Name or A/C No..."
//                 options={customers.map((acc) => ({
//                   value: acc.id,
//                   label: `${acc.fullName} | ${acc.userId}`,
//                   account: acc
//                 }))}
//                 value={selectedAccount ? { value: selectedAccount.id, label: `${selectedAccount.fullName} | ${selectedAccount.userId}` } : null}
//                onChange={(selected) => {
//                   setSelectedAccount(selected?.account);
//                   setFilterValue(selected?.account?.userId); // ✅ FIX
//                 }}
//                   isSearchable
//               />
//             )}

//             <button onClick={handleSearch}>Search</button>
//           </div>
//         </div>
//     </section>

//     {/* User Details */}

//       {userDetails && (
//           <section className="BranchLoanKycUpload-section">
//             <h2>2. User Details</h2>
//             <div className="table-wrapper">
//               <table className="BranchLoanKycUpload-user-details-table">
//                 <tbody>
//                   <tr>
//                     <th>Customer ID :-</th>
//                     <td>{userDetails.userId}</td>

//                     <th>Name :-</th>
//                     <td>{userDetails.name}</td>

//                     <th>PAN :-</th>
//                     <td>{userDetails.pan}</td>
//                   </tr>
//                   <tr>

//                     <th>Aadhaar :-</th>
//                     <td>{userDetails.aadhaar}</td>

//                     <th>Mobile :-</th>
//                     <td>{userDetails.mobile}</td>

//                     <th>Date of Birth :-</th>
//                     <td>{userDetails.dob}</td>
//                   </tr>
//                   {/* <tr>
//                     <th>Customer ID</th>
//                     <td>{userDetails.Id}</td>
//                   </tr> */}
//                   <tr>

//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </section>
//         )}

//       {/* Upload Document */}
//       <section className="BranchLoanKycUpload-section">
//         <h2>3. Upload KYC Document</h2>
//         <div className="BranchLoanKycUpload-upload-row">
//           <select value={docType} onChange={(e) => setDocType(e.target.value)}>
//               <option value="">Choose Document Type</option>
//              {documents.map((doc, idx) => (
//     <option key={idx} value={doc.name}>
//       {doc.name}
//     </option>
//   ))}
//           </select>

//           {docType && (
//             <>
//               <input
//                 type="file"
//                 onChange={(e) =>
//                   e.target.files && setDocFile(e.target.files[0])
//                 }
//               />
//               {docFile && <span>{docFile.name}</span>}
//             </>
//           )}

//         <button onClick={handleUpload}>Upload</button>
//       </div>
//     </section>

//     {/* Display Uploaded Documents */}
//     {/* <section className="BranchLoanKycUpload-section">
//         <h2>4. Customer KYC Document Details</h2>
//         <div className="table-wrapper">
//           <table className="BranchLoanKycUpload-table">
//             <thead>
//               <tr>
//                 <th>S.No</th>
//                 <th>Document Name</th>
//                 <th>Status</th>
//                 <th>Preview</th>
//               </tr>
//             </thead>
//             <tbody>
//               {uploadedKyc.length > 0 ? (
//                 uploadedKyc.map((doc, idx) => (
//                   <tr key={doc.id}>
//                     <td>{idx + 1}</td>
//                     <td>{doc.docName}</td>
//                     <td>{doc.status}</td>
//                     <td>
//                       {doc.docImage ? (
//                         <a
//                           href={`https://payyug.in/uploads/${doc.docImage}`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           Preview
//                         </a>
//                       ) : (
//                         "N/A"
//                       )}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="4" style={{ textAlign: "center" }}>
//                     {userDetails
//                       ? "No documents found"
//                       : "Please search a user to view documents"}
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </section> */}

//       {/* Display Uploaded Documents */}
//       <section className="BranchLoanKycUpload-section">
//         <h2>4. Customer KYC Document Details</h2>
//         <div className="table-wrapper">
//           <table className="BranchLoanKycUpload-table">
//             <thead>
//               <tr>
//                 <th>S.No</th>
//                 <th>Document Name</th>
//                 <th>Status</th>
//                 <th>Preview</th>
//                 <th>Action</th> {/* New column */}
//               </tr>
//             </thead>
//             <tbody>
//               {uploadedKyc.length > 0 ? (
//                 uploadedKyc.map((doc, idx) => (
//                   <tr key={doc.id}>
//                     <td>{idx + 1}</td>
//                     <td>{doc.docName}</td>
//                     <td>{doc.status}</td>
//                     <td>
//                       {/* {doc.docImage ? (
//                         <a
//                           href={`https://payyug.in/uploads/${doc.docImage}`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           Preview
//                         </a>
//                       ) : (
//                         "N/A"
//                       )} */}

//                       <button style={{background:"none", textDecoration:"underline"}}  onClick={()=> handlepreviewclick(doc)}>preview</button>
//                     </td>
//                   <td>
//                       <button
//                         className="delete-btn"
//                         onClick={() => handleDelete(doc.id)}
//                         disabled={doc.status?.toLowerCase() === "approved"}
//                       >
//                         Delete
//                       </button>
//                     </td>

//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="5" style={{ textAlign: "center" }}>
//                     {userDetails
//                       ? "No documents found"
//                       : "Please search a user to view documents"}
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </section>

//       {previewImage && (
//           <div className="modal-overlay-customer-report" onClick={() => setPreviewImage(null)}>
//             <div className="modal-content-customer-report" onClick={(e) => e.stopPropagation()}>
//               <img src={previewImage} alt="KYC Preview" className="modal-image" />
//               <button
//                 className="modal-content-customer-report-close-btn"
//                 onClick={() => setPreviewImage(null)}
//               >
//                 ×
//               </button>
//             </div>
//           </div>
//         )}

//     </div>
//   );
// }

/* eslint-disable no-unused-vars */



import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import imageCompression from "browser-image-compression";

import axios from "axios";
import "../assets/Loan/LoanKyc.css";

import { fetchDocuments } from "../redux/slices/kycuploadslice"; // <-- import your slice
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";

import Select from "react-select";
import { fetchCustomers } from "../redux/slices/Customer/customerReportSlice";
export default function KycForm() {
  const dispatch = useDispatch();
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [userDetails, setUserDetails] = useState(null);
  const [docType, setDocType] = useState("");
  const [docFile, setDocFile] = useState(null);
  const [uploadedKyc, setUploadedKyc] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [fileError, setFileError] = useState("");
  const [showResizeBtn, setShowResizeBtn] = useState(false);

  const MAX_SIZE = 100 * 1024; //100KB

  const { profile, loading: profileLoading } = useSelector(
    (state) => state.userProfile,
  );

  const { documents, loading, error } = useSelector((state) => state.documents);
  // Fetch profile
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profile && profile.superAdminId) {
      dispatch(
        fetchDocuments({
          serviceId: profile.superAdminId,
          description: "Customer",
        }),
      );
    }
  }, [dispatch, profile]);

  const { customers = [] } = useSelector((state) => state.customerReport || {});

  useEffect(() => {
    if (!profile?.superAdminId) return;

    dispatch(
      fetchCustomers({
        limit: Number(1000),
        superAdminId: profile.superAdminId,
        userId: undefined,
      }),
    );
  }, [dispatch, profile?.superAdminId]);

  const handleDelete = async (docId) => {
    if (!window.confirm("Are you sure you want to delete this document?"))
      return;

    try {
      const res = await fetch(
        `https://payyug.in/api/delete-customer-kyc/${docId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            // Add auth token if required
            // Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!res.ok) throw new Error("Failed to delete document");

      // Remove deleted document from local state
      setUploadedKyc(uploadedKyc.filter((doc) => doc.id !== docId));

      toast.success(res?.data?.message || "Document deleted successfully");
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Error deleting document");
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setFileError("");
    setShowResizeBtn(false);

    if (!file.type.startsWith("image/")) {
      toast.error("Only image files allowed");
      setFileError("Only image files allowed");
      return;
    }

    setDocFile(file);

    if (file.size > MAX_SIZE) {
      toast.error(
        `Image size ${(file.size / 1024).toFixed(2)}KB exceeds 100KB`,
      );

      setFileError(`Image exceeds 100KB. Please resize image before upload`);

      setShowResizeBtn(true);

      return;
    }
  };

  const handleResize = async () => {
    if (!docFile) return;

    try {
      const options = {
        maxSizeMB: 0.1,
        maxWidthOrHeight: 1200,
        useWebWorker: true,
      };

      const compressedFile = await imageCompression(docFile, options);

      setDocFile(compressedFile);

      setShowResizeBtn(false);
      setFileError("");

      toast.success(
        `Image resized to ${(compressedFile.size / 1024).toFixed(2)}KB`,
      );
    } catch (err) {
      console.log(err);
      toast.error("Resize failed");
    }
  };

  // ------------------ Search User ------------------
  const handleSearch = async () => {
    if (!filterValue) {
      toast.warn("Please enter a value to search.");
      return;
    }

    const branchId = localStorage.getItem("userId") || "18";
    let query = { branchId };

    if (filterType === "customer id") query.userId = filterValue.trim();
    else if (filterType === "pan") query.panNumber = filterValue.trim();
    else if (filterType === "aadhaar") query.aadhaarNumber = filterValue.trim();
    else if (filterType === "mobile") query.mobileNumber = filterValue.trim();
    else {
      toast.error("This filter type is not supported for API search.");
      return;
    }

    try {
      // Fetch user details
      const response = await axios.get(
        "https://payyug.in/api/customers-get-userId",
        { params: query },
      );

      const user = response.data.data;
      if (user && user.userId) {
        const details = {
          userId: user.userId,
          Id: user.id,
          name: user.fullName,
          pan: user.panNumber,
          aadhaar: user.aadhaarNumber,
          mobile: user.mobileNumber,
          dob: user.dateOfBirth?.slice(0, 10),
          superAdminId: user.superAdminId,
        };
        setUserDetails(details);

        // Fetch uploaded KYC for this user
        const kycResponse = await axios.get(`https://payyug.in/api/list-kyc`, {
          params: {
            userId: user.userId,

            createdId: branchId,
          },
        });

        console.log("customer photo", kycResponse.data);
        setUploadedKyc(kycResponse.data.documents || []);
      } else {
        setUserDetails(null);
        setUploadedKyc([]);
        toast.error("No user found.");
      }
    } catch (error) {
      console.error("Error fetching user or KYC:", error);
      toast.error("Failed to fetch user or KYC. Please try again.");
    }
  };

  // ------------------ Upload/Create KYC ------------------
  const handleUpload = async () => {
    if (!docType || !docFile || !userDetails?.userId) {
      toast.warn(
        "Please select a document type, file, and ensure a user is selected.",
      );
      return;
    }

    const createdId = localStorage.getItem("userId") || 123;
    const createdBy = localStorage.getItem("username") || "demo";

    try {
      const formData = new FormData();
      formData.append("userId", userDetails.userId);
      formData.append("superAdminId", userDetails.superAdminId);
      formData.append("docName", docType);
      formData.append("file", docFile);
      formData.append("status", "pending");
      formData.append("createdBy", createdBy);
      formData.append("createdId", createdId);

      await axios.post("https://payyug.in/api/create-customer-kyc", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // Refresh KYC list after upload
      const kycResponse = await axios.get(`https://payyug.in/api/list-kyc`, {
        params: {
          userId: userDetails.userId,
          createdId: createdId,
        },
      });
      setUploadedKyc(kycResponse.data.documents || []);

      setDocType("");
      setDocFile(null);
      toast.success(
        kycResponse?.data?.message || "KYC document uploaded successfully!",
      );
    } catch (err) {
      console.error("Upload error:", err);
      toast.error(
        err?.response?.data?.message ||
          "Failed to upload KYC. Please try again.",
      );
    }
  };

  const handlepreviewclick = async (doc) => {
    try {
      const imageUrl = `https://payyug.in/uploads/${doc.docImage}`;

      if (imageUrl) {
        setPreviewImage(imageUrl);
      } else {
        toast.error("Image not found.");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error loading image.");
    }
  };

  // ------------------ JSX ------------------
  return (
    <div className="BranchLoanKycUpload-container">
      <h1>Customer KYC Upload</h1>

      {/* Filter User */}
      <section className="BranchLoanKycUpload-section">
        <h2>1. Filter User</h2>
        <div className="BranchLoanKycUpload-filter-row-wrapper">
          <div className="BranchLoanKycUpload-filter-row">
            <select
              value={filterType}
              onChange={(e) => {
                setFilterType(e.target.value);
                setFilterValue("");
              }}
            >
              <option value="">Select Filter Type</option>
              <option value="customer id">Customer ID</option>
              {/* <option value="pan">PAN</option>
              <option value="aadhaar">Aadhaar</option>
              <option value="mobile">Mobile</option> */}
            </select>

            {filterType && (
              // <input
              //   type="text"
              //   placeholder={`Enter ${filterType}`}
              //   value={filterValue}
              //   onChange={(e) => setFilterValue(e.target.value)}
              // />

              <Select
                className="account-select-container"
                classNamePrefix="account-select"
                placeholder="Search by Name or A/C No..."
                options={customers.map((acc) => ({
                  value: acc.id,
                  label: `${acc.fullName} | ${acc.userId}`,
                  account: acc,
                }))}
                value={
                  selectedAccount
                    ? {
                        value: selectedAccount.id,
                        label: `${selectedAccount.fullName} | ${selectedAccount.userId}`,
                      }
                    : null
                }
                onChange={(selected) => {
                  setSelectedAccount(selected?.account);
                  setFilterValue(selected?.account?.userId); // ✅ FIX
                }}
                isSearchable
              />
            )}

            <button onClick={handleSearch}>Search</button>
          </div>
        </div>
      </section>

      {/* User Details */}

      {userDetails && (
        <section className="BranchLoanKycUpload-section">
          <h2>2. User Details</h2>
          <div className="table-wrapper">
            <table className="BranchLoanKycUpload-user-details-table">
              <tbody>
                <tr>
                  <th>Customer ID :-</th>
                  <td>{userDetails.userId}</td>

                  <th>Name :-</th>
                  <td>{userDetails.name}</td>

                  <th>PAN :-</th>
                  <td>{userDetails.pan}</td>
                </tr>
                <tr>
                  <th>Aadhaar :-</th>
                  <td>{userDetails.aadhaar}</td>

                  <th>Mobile :-</th>
                  <td>{userDetails.mobile}</td>

                  <th>Date of Birth :-</th>
                  <td>{userDetails.dob}</td>
                </tr>
                {/* <tr>
                    <th>Customer ID</th>
                    <td>{userDetails.Id}</td>
                  </tr> */}
                <tr></tr>
              </tbody>
            </table>
          </div>
        </section>
      )}

      {/* Upload Document */}
      <section className="BranchLoanKycUpload-section">
        <h2>3. Upload KYC Document</h2>
        <div className="BranchLoanKycUpload-upload-row">
          <select value={docType} onChange={(e) => setDocType(e.target.value)}>
            <option value="">Choose Document Type</option>
            {documents.map((doc, idx) => (
              <option key={idx} value={doc.name}>
                {doc.name}
              </option>
            ))}
          </select>

          {docType && (
            <>
              <input type="file" accept="image/*" onChange={handleFileChange} />
              {docFile && (
                <div className="file-preview-box">
                  <span>{docFile.name}</span>

                  <p>
                    Size:
                    {(docFile.size / 1024).toFixed(2)} KB
                  </p>
                </div>
              )}

              {fileError && <div className="kyc-error-box">{fileError}</div>}

              {showResizeBtn && (
                <button
                  type="button"
                  className="resize-btn"
                  onClick={handleResize}
                >
                  Resize Image
                </button>
              )}
            </>
          )}

          <button className="resize-btn" onClick={handleUpload}>
            Upload
          </button>
        </div>
      </section>

      {/* Display Uploaded Documents */}
      {/* <section className="BranchLoanKycUpload-section">
        <h2>4. Customer KYC Document Details</h2>
        <div className="table-wrapper">
          <table className="BranchLoanKycUpload-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Document Name</th>
                <th>Status</th>
                <th>Preview</th>
              </tr>
            </thead>
            <tbody>
              {uploadedKyc.length > 0 ? (
                uploadedKyc.map((doc, idx) => (
                  <tr key={doc.id}>
                    <td>{idx + 1}</td>
                    <td>{doc.docName}</td>
                    <td>{doc.status}</td>
                    <td>
                      {doc.docImage ? (
                        <a
                          href={`https://payyug.in/uploads/${doc.docImage}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Preview
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    {userDetails
                      ? "No documents found"
                      : "Please search a user to view documents"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section> */}

      {/* Display Uploaded Documents */}
      <section className="BranchLoanKycUpload-section">
        <h2>4. Customer KYC Document Details</h2>
        <div className="table-wrapper">
          <table className="BranchLoanKycUpload-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Document Name</th>
                <th>Status</th>
                <th>Preview</th>
                <th>Action</th> {/* New column */}
              </tr>
            </thead>
            <tbody>
              {uploadedKyc.length > 0 ? (
                uploadedKyc.map((doc, idx) => (
                  <tr key={doc.id}>
                    <td>{idx + 1}</td>
                    <td>{doc.docName}</td>
                    <td>{doc.status}</td>
                    <td>
                      {/* {doc.docImage ? (
                        <a
                          href={`https://payyug.in/uploads/${doc.docImage}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Preview
                        </a>
                      ) : (
                        "N/A"
                      )} */}

                      <button
                        style={{
                          background: "none",
                          textDecoration: "underline",
                        }}
                        onClick={() => handlepreviewclick(doc)}
                      >
                        preview
                      </button>
                    </td>
                    <td>
                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(doc.id)}
                        disabled={doc.status?.toLowerCase() === "approved"}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    {userDetails
                      ? "No documents found"
                      : "Please search a user to view documents"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      {previewImage && (
        <div
          className="modal-overlay-customer-report"
          onClick={() => setPreviewImage(null)}
        >
          <div
            className="modal-content-customer-report"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={previewImage} alt="KYC Preview" className="modal-image" />
            <button
              className="modal-content-customer-report-close-btn"
              onClick={() => setPreviewImage(null)}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
